import { CircularProgress, Grid } from '@material-ui/core';
import { Button, Dialog, Icons, Typography } from '@nutrien/cxp-components';
import React, { useEffect, useState } from 'react';

import { ISignAndStampData } from '../../models/models';
import { isJestTest } from '../../test-helpers/isJestTest';
import { useFileStorage, useOnlineStatus } from '../../utilities';
import { XML_HEADER } from '../../utilities/constants';
import signAndStampStyles from '../SignAndStamp/SignAndStamp.styles';
interface Props {
  data: ISignAndStampData;
  onDelete?: (file: ISignAndStampData) => void;
  readonly?: boolean;
}

const SignAndStampFIView: React.FC<Props> = ({ data, onDelete, readonly }) => {
  const { fileUUID, updatedName, fileData, category }: ISignAndStampData = data;
  const online = useOnlineStatus();
  const classes = signAndStampStyles();
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const { getAttachmentFromIndexDB, retryFileDownload } = useFileStorage();
  const [imageURL, setImageURL] = useState('');
  const [fileLoading, setFileLoading] = useState<boolean>(false);
  const imgRef = React.createRef<HTMLImageElement>();

  const getS3URL = async (fileId: string) => {
    let blobFile: Blob = (await getAttachmentFromIndexDB(fileId)) as Blob;
    if (online && !isJestTest() && (!blobFile || blobFile.type === XML_HEADER) && data.filePath) {
      setFileLoading(true);
      blobFile = await retryFileDownload(data.filePath, fileId);
      setFileLoading(false);
    }
    const url = blobFile ? URL.createObjectURL(blobFile) : '';
    setImageURL(url);
    return url;
  };

  useEffect(() => {
    if (fileData) {
      const url = URL.createObjectURL(fileData);
      setImageURL(url);
    } else if (fileUUID) {
      getS3URL(fileUUID);
    }
  }, [fileUUID, fileData]);

  const removeSignImage = async () => {
    setDeleteConfirm(true);
  };

  const handleDelete = (fileToDelete: ISignAndStampData) => {
    if (onDelete && fileToDelete) onDelete(fileToDelete);
    setDeleteConfirm(false);
  };

  return (
    <>
      <Grid xs={12} container className={classes.signUploadContainer}>
        <Grid item xs={3}>
          <Grid item xs={2} className={classes.stampImagePreview}>
            {readonly && <Grid className={classes.noContentDiv} />}
            {!readonly && (
              <>
                <Grid item justifyContent="flex-end" className={classes.xfeatherOuterCircle}>
                  <Grid className={classes.xfeatherInnerCircle}>
                    <Icons.XFeather
                      color="primary"
                      height="23px"
                      width="22px"
                      onClick={removeSignImage}
                      data-testid={`delete-${updatedName}`}
                    />
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
          <Grid className={`${classes.signImageDiv} ${fileLoading && classes.loadingStamp}`}>
            {!fileLoading ? (
              <img
                src={imageURL}
                ref={imgRef}
                alt="selected upload"
                className={classes.signImage}
                data-testid={`image-of-${updatedName}`}
              />
            ) : (
              <CircularProgress />
            )}
          </Grid>
        </Grid>
      </Grid>

      {deleteConfirm && (
        <Dialog
          onClose={() => setDeleteConfirm(false)}
          open={deleteConfirm}
          titleText="Delete File"
          backButton={false}
          dialogActions={
            <Grid
              container
              justifyContent="flex-end"
              alignItems="center"
              className={classes.deleteDialogActionGrid}
            >
              <Grid item>
                <Button
                  noMinHeight
                  color="error"
                  variant="contained"
                  onClick={() => {
                    handleDelete(data);
                  }}
                >
                  Yes, Delete
                </Button>
              </Grid>
            </Grid>
          }
          maxWidth="xs"
          noMinHeight
        >
          <Grid container className={classes.deleteContainerGrid}>
            <Grid item container xs={12} alignItems="center">
              <Typography>{`Are you sure want to delete ${updatedName}-${category} ?`}</Typography>
            </Grid>
          </Grid>
        </Dialog>
      )}
    </>
  );
};

export default SignAndStampFIView;
